/** Megyénkénti autószám a térképhez és szűrőhöz. */
export function buildCountyCounts(cars) {
  const counts = {};
  for (const c of cars || []) {
    const county = c?.county;
    if (!county) continue;
    counts[county] = (counts[county] || 0) + 1;
  }
  return counts;
}

export function parseCountyParam(raw) {
  if (!raw) return [];
  return raw
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
}

export function countyParamFromList(list) {
  if (!list?.length) return "";
  return list.join(",");
}
